import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import sesh from '../utilities/sessionStorage';
import Footer from '@employee/footer';

const propTypes = {
    footerDataUrl: PropTypes.string.isRequired
};

const defaultProps = {};

class FooterContainer extends Component {
    constructor(props) {
        super(props);

        this.caches = {
            legal: 'mfa-footer-legal'
        };

        this.state = {
            footerCopy: sesh.getSessionStorage(this.caches.legal) || null
        };

        this.getData = this.getData.bind(this);
    }

    componentDidMount() {
        this.getData();
    }

    getLegalMarkup() {
        axios.get(this.props.footerDataUrl).then(response => {
            if (response.data) {
                var content = [
                    response.data.disclosure,
                    '<p class="asc-footer-copyright">',
                    response.data.copyright,
                    '</p>'
                ].join('');

                this.setState({
                    footerCopy: content
                });

                sesh.setSessionStorage(this.caches.legal, content);
            }
        });
    }

    getData() {
        let { footerCopy } = this.state;

        if (footerCopy === null) {
            this.getLegalMarkup();
        }
    }

    render() {
        let { footerCopy } = this.state;

        return <Footer copyright={footerCopy} />;
    }
}

FooterContainer.propTypes = propTypes;
FooterContainer.defaultProps = defaultProps;
export default FooterContainer;
